import { imprimir } from '@/utils/RelatorioHTML'
import QRCode from 'qrcode'

// ─── Helpers de formatação ────────────────────────────────────────────────────

function fmtDate (d) {
  if (!d) return ''
  const dt = new Date(d)
  if (isNaN(dt.getTime())) return ''
  return dt.toLocaleDateString('pt-BR', { timeZone: 'UTC' })
}

function fmtMoeda (v) {
  if (v == null || v === '') return ''
  return Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

function fmtNum (v, dec = 3) {
  if (v == null || v === '') return ''
  return Number(v).toLocaleString('pt-BR', { minimumFractionDigits: dec, maximumFractionDigits: dec })
}

function fmtPerc (v) {
  if (v == null || v === '') return ''
  const n = Number(v)
  if (!n) return ''
  return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

function esc (str) {
  if (str == null) return ''
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

// ─── Estilos CSS ─────────────────────────────────────────────────────────────

function buildStyles () {
  return `<style>
  * { box-sizing: border-box; margin: 0; padding: 0 }
  body {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 8pt;
    color: #1a1a1a;
    background: #fff;
    padding: 4mm;
  }
  @media print {
    @page { size: A4 portrait; margin: 10mm 15mm }
    body { padding: 0; }
    .no-print { display: none !important; }
  }

  /* ─── CABEÇALHO DA EMPRESA ─── */
  .doc-header {
    display: grid;
    grid-template-columns: 1fr auto;
    border: 2px solid #1a3a5c;
    margin-bottom: 3px;
  }
  .empresa-block {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 7px 10px;
  }
  .empresa-logo img {
    max-height: 52px;
    max-width: 90px;
    object-fit: contain;
  }
  .empresa-info .nome {
    font-size: 10pt;
    font-weight: bold;
    color: #1a3a5c;
    line-height: 1.2;
  }
  .empresa-info .razao {
    font-size: 7.5pt;
    color: #444;
  }
  .empresa-info .detalhe {
    font-size: 7pt;
    color: #666;
    margin-top: 1px;
  }
  .doc-side {
    border-left: 2px solid #1a3a5c;
    background: #f0f5f9;
    padding: 7px 14px;
    text-align: right;
    min-width: 155px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1px;
  }
  .doc-titulo {
    font-size: 13pt;
    font-weight: bold;
    letter-spacing: 3px;
    color: #1a3a5c;
    line-height: 1;
  }
  .doc-numero {
    font-size: 20pt;
    font-weight: bold;
    color: #1a3a5c;
    line-height: 1.05;
  }
  .doc-ctrl {
    font-size: 7pt;
    color: #777;
  }
  .doc-data {
    font-size: 7.5pt;
    color: #333;
    margin-top: 2px;
  }
  .doc-situacao {
    display: inline-block;
    margin-top: 4px;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 6.5pt;
    font-weight: bold;
    background: #1a3a5c;
    color: #fff;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }

  /* ─── RÓTULO DE SEÇÃO ─── */
  .sec-label {
    background: #1a3a5c;
    color: #fff;
    padding: 2px 8px;
    font-size: 7.5pt;
    font-weight: bold;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }

  /* ─── BLOCO DE IDENTIFICAÇÃO ─── */
  .ident-block {
    display: grid;
    grid-template-columns: 1fr 1fr;
    border: 1px solid #b0bec5;
    border-top: none;
    margin-bottom: 3px;
  }
  .ident-col { padding: 5px 8px; }
  .ident-col:first-child { border-right: 1px solid #b0bec5; }
  .frow {
    display: flex;
    align-items: baseline;
    margin-bottom: 2px;
    line-height: 1.35;
  }
  .flabel {
    color: #666;
    font-size: 7pt;
    min-width: 72px;
    flex-shrink: 0;
  }
  .fval {
    font-weight: 600;
    flex: 1;
    word-break: break-word;
    font-size: 8pt;
  }
  .fval-sm { font-size: 7pt; font-weight: 500; }

  /* ─── TABELA DE ITENS ─── */
  table.items {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 3px;
  }
  table.items thead th {
    background: #1a3a5c;
    color: #fff;
    padding: 3px 4px;
    border: 1px solid #8ba7bf;
    text-align: center;
    font-weight: bold;
    font-size: 7pt;
    white-space: nowrap;
  }
  table.items thead th.left { text-align: left; }
  table.items tbody td {
    border: 1px solid #cfd8dc;
    padding: 2px 4px;
    vertical-align: middle;
    font-size: 7.5pt;
  }
  table.items tbody tr:nth-child(4n+1) td,
  table.items tbody tr:nth-child(4n+2) td { background: #f9fafc; }
  table.items tbody tr.lote-row td {
    background: #f3f6f9 !important;
    font-style: italic;
    font-size: 6.5pt;
    color: #666;
    padding: 1px 4px 1px 22px;
    border-top: none;
  }
  table.items tfoot td {
    background: #e8f0f5;
    border: 1px solid #b0bec5;
    padding: 2px 4px;
    font-weight: bold;
    font-size: 7.5pt;
  }
  .r { text-align: right; }
  .c { text-align: center; }
  .conf-box {
    width: 11px;
    height: 11px;
    border: 1px solid #777;
    display: inline-block;
    vertical-align: middle;
  }

  /* ─── RODAPÉ DA TABELA / TOTAIS ─── */
  .bottom-section {
    display: grid;
    grid-template-columns: 2fr 1.1fr 1.5fr;
    border: 1px solid #b0bec5;
    border-top: none;
    margin-bottom: 3px;
  }
  .bot-box { padding: 5px 8px; }
  .bot-box + .bot-box { border-left: 1px solid #b0bec5; }
  .bot-title {
    font-size: 7pt;
    font-weight: bold;
    color: #1a3a5c;
    text-align: center;
    border-bottom: 1px solid #cfd8dc;
    padding-bottom: 2px;
    margin-bottom: 4px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .fin-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2px;
    font-size: 7.5pt;
  }
  .fin-label { color: #666; font-size: 7pt; }
  .fin-val { font-weight: 600; }
  .tot-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2px;
    font-size: 7.5pt;
  }
  .tot-label { color: #555; font-size: 7pt; }
  .tot-val { text-align: right; }
  .tot-grand {
    border-top: 2px solid #1a3a5c;
    margin-top: 5px;
    padding-top: 3px;
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    font-size: 9pt;
    color: #1a3a5c;
  }
  .obs-text {
    font-size: 7.5pt;
    color: #333;
    white-space: pre-wrap;
    word-break: break-word;
  }

  /* ─── PARCELAMENTO ─── */
  .parc-section {
    border: 1px solid #b0bec5;
    border-top: none;
    margin-bottom: 3px;
  }
  .parc-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }
  .parc-item {
    padding: 3px 7px;
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }
  .parc-item:nth-child(4n) { border-right: none; }
  .parc-lbl { font-size: 6.5pt; color: #999; }
  .parc-date { font-size: 7.5pt; font-weight: 500; }
  .parc-val { font-size: 8pt; font-weight: bold; color: #1a3a5c; text-align: right; }

  /* ─── PESAGEM ─── */
  .pesagem-section {
    border: 1px solid #b0bec5;
    border-top: none;
    margin-bottom: 3px;
  }
  .pesagem-produto-hdr {
    background: #e8f0f5;
    padding: 2px 8px;
    font-size: 7.5pt;
    font-weight: bold;
    color: #1a3a5c;
    border-bottom: 1px solid #cfd8dc;
  }
  table.pesagem-tbl {
    width: 100%;
    border-collapse: collapse;
    font-size: 7pt;
  }
  table.pesagem-tbl th {
    background: #f0f4f8;
    border: 1px solid #cfd8dc;
    padding: 2px 4px;
    text-align: center;
    font-size: 6.5pt;
  }
  table.pesagem-tbl td {
    border: 1px solid #e0e0e0;
    padding: 2px 4px;
    text-align: right;
  }
  table.pesagem-tbl tr:nth-child(even) td { background: #fafbfc; }

  /* ─── VALIDAÇÃO DO DOCUMENTO ─── */
  .validacao-section {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    border: 1px solid #b0bec5;
    border-top: none;
    margin-bottom: 3px;
    padding: 8px 10px;
    background: #f8fafc;
  }
  .qr-img { flex-shrink: 0; }
  .qr-info { font-size: 8pt; color: #333; line-height: 1.8; }
  .qr-info strong { color: #1a3a5c; }
  .qr-hint { font-size: 7pt; color: #888; font-style: italic; margin-top: 4px; }

  /* ─── ASSINATURAS ─── */
  .assinatura-section {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    border: 1px solid #b0bec5;
    border-top: none;
    margin-bottom: 3px;
  }
  .assin-box {
    padding: 4px 12px 8px;
    text-align: center;
  }
  .assin-box + .assin-box { border-left: 1px solid #b0bec5; }
  .assin-line {
    border-top: 1px solid #333;
    margin: 22px auto 4px;
    width: 85%;
  }
  .assin-label { font-size: 7.5pt; font-weight: bold; color: #1a3a5c; }
  .assin-sub { font-size: 6.5pt; color: #666; margin-top: 2px; }

  /* ─── RODAPÉ DA PÁGINA ─── */
  .doc-footer {
    border-top: 1px solid #b0bec5;
    padding-top: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 6.5pt;
    color: #888;
    margin-top: 3px;
  }
  .doc-footer strong { color: #1a3a5c; }
</style>`
}

// ─── Blocos HTML ──────────────────────────────────────────────────────────────

function buildCompanyHeader (cab) {
  const logoHtml = (cab.OP_IMPRIME_LOGO_VENDA === '1' && cab.LOGO)
    ? `<div class="empresa-logo"><img src="data:image/png;base64,${cab.LOGO}" alt="Logo" /></div>`
    : ''

  const nomeEmpresa = cab.FANTASIA || cab.TX_RAZAO_SOCIAL || ''
  const mostrarRazao = cab.FANTASIA && cab.TX_RAZAO_SOCIAL && cab.FANTASIA !== cab.TX_RAZAO_SOCIAL

  return `
<div class="doc-header">
  <div class="empresa-block">
    ${logoHtml}
    <div class="empresa-info">
      <div class="nome">${esc(nomeEmpresa)}</div>
      ${mostrarRazao ? `<div class="razao">${esc(cab.TX_RAZAO_SOCIAL)}</div>` : ''}
      ${cab.ENDERECO_EMPRESA ? `<div class="detalhe">${esc(cab.ENDERECO_EMPRESA)}</div>` : ''}
      <div class="detalhe">
        ${cab.CNPJ_EMPRESA ? 'CNPJ: ' + esc(cab.CNPJ_EMPRESA) : ''}
        ${cab.IE_EMPRESA ? ' | IE: ' + esc(cab.IE_EMPRESA) : ''}
        ${cab.TX_TELEFONE_EMPRESA ? ' | Fone: ' + esc(cab.TX_TELEFONE_EMPRESA) : ''}
      </div>
    </div>
  </div>
  <div class="doc-side">
    <div class="doc-titulo">FATURA</div>
    <div class="doc-numero">${esc(String(cab.N_VENDA || ''))}</div>
    <div class="doc-ctrl">Controle: ${cab.SEQUENCIA}</div>
    <div class="doc-data">
      ${cab.DT_SAIDA ? 'Data: <b>' + fmtDate(cab.DT_SAIDA) + '</b>' : ''}
      ${cab.USUARIO_CADASTRO ? ' | Usuário: ' + esc(cab.USUARIO_CADASTRO) : ''}
    </div>
    <div><span class="doc-situacao">${esc(cab.SITUACAO_TRADUZIDO || '')}</span></div>
  </div>
</div>`
}

function campo (label, val, sm = false) {
  if (!val && val !== 0) return ''
  return `<div class="frow">
    <span class="flabel">${label}:</span>
    <span class="fval${sm ? ' fval-sm' : ''}">${esc(String(val))}</span>
  </div>`
}

function buildIdentBlock (cab) {
  const endCli = [
    cab.ENDERECO_CLI,
    cab.NUMERO_CLI ? 'Nº ' + cab.NUMERO_CLI : null,
    cab.COMPLEMENTO
  ].filter(Boolean).join(', ')

  const cidUf = [cab.NOME_MUNICIPIO, cab.ID_UF].filter(Boolean).join(' - ')
  const formaPgto = cab.OP_FORMA_PAGTO === 'V' ? 'À VISTA' : (cab.OP_FORMA_PAGTO === 'P' ? 'A PRAZO' : (cab.FORMA || ''))

  return `
<div class="sec-label">Identificação e Endereço</div>
<div class="ident-block">
  <div class="ident-col">
    ${campo('Cliente', cab.NOME)}
    ${campo('CNPJ/CPF', cab.CGC)}
    ${campo('IE', cab.INS_EST)}
    ${campo('Endereço', endCli)}
    ${campo('Bairro', cab.BAIRRO_CLI)}
    ${campo('Cidade/UF', cidUf, true)}
    ${campo('CEP', cab.CEP)}
    ${campo('Telefone', cab.TELEFONE)}
  </div>
  <div class="ident-col">
    ${campo('Entrega/Rota', cab.NENTREGA)}
    ${campo('Forma Pgto', formaPgto)}
    ${campo('Motorista', cab.NOME_MOTORISTA)}
    ${campo('Vendedor', cab.NOME_VENDEDOR)}
    ${campo('Data Pedido', cab.DT_PEDIDO ? fmtDate(cab.DT_PEDIDO) : '')}
    ${campo('Placa', cab.PLACA)}
    ${campo('Obs Pedido', cab.OBS_PEDIDO, true)}
  </div>
</div>`
}

function buildItemsTable (itens) {
  const rows = itens.map((item) => {
    // LOTES vem como array do backend (query separada, sem problema de BLOB)
    // TX_LOTES_ITEM vinha vazio pois LIST() do Firebird retorna BLOB não lido pelo driver
    let loteTexto = null
    if (item.LOTES && item.LOTES.length > 0) {
      loteTexto = item.LOTES
        .map(l => `${esc(l.LOTE)} (${Number(l.QUANT_PLANEJADA || 0).toLocaleString('pt-BR', { minimumFractionDigits: 3 })})`)
        .join(', ')
    } else if (item.TX_LOTES_ITEM && typeof item.TX_LOTES_ITEM === 'string') {
      loteTexto = esc(item.TX_LOTES_ITEM)
    }
    const loteRow = loteTexto
      ? `<tr class="lote-row"><td colspan="10">Lotes: ${loteTexto}</td></tr>`
      : ''
    return `<tr>
      <td class="c">${esc(String(item.COD_PRO || ''))}</td>
      <td>${esc(item.NOME_PRODUTO || '')}</td>
      <td class="r">${item.PECAS ? fmtNum(item.PECAS, 0) : ''}</td>
      <td class="r">${fmtNum(item.QUANT)}</td>
      <td class="c">${esc(item.TX_UNIDADE_COMERCIAL || item.UND_ENT || '')}</td>
      <td class="r">${fmtMoeda(item.VL_UNT)}</td>
      <td class="r">${fmtPerc(item.VL_ICMS_ALIQUOTA)}</td>
      <td class="r">${fmtPerc(item.VL_IPI_ALIQUOTA)}</td>
      <td class="r">${fmtMoeda(item.TOTAL_PRODUTO)}</td>
      <td class="c"><span class="conf-box"></span></td>
    </tr>${loteRow}`
  }).join('')

  const totalQuant = itens.reduce((s, i) => s + (Number(i.QUANT) || 0), 0)
  const totalPecas = itens.reduce((s, i) => s + (Number(i.PECAS) || 0), 0)
  const totalValor = itens.reduce((s, i) => s + (Number(i.TOTAL_PRODUTO) || 0), 0)

  return `
<table class="items">
  <thead>
    <tr>
      <th style="width:50px">CÓDIGO</th>
      <th class="left">DESCRIÇÃO</th>
      <th style="width:38px">PÇS</th>
      <th style="width:48px">QUANT</th>
      <th style="width:32px">UND</th>
      <th style="width:58px">PREÇO</th>
      <th style="width:40px">%ICMS</th>
      <th style="width:36px">%IPI</th>
      <th style="width:62px">TOTAL</th>
      <th style="width:26px">CONF</th>
    </tr>
  </thead>
  <tbody>${rows}</tbody>
  <tfoot>
    <tr>
      <td colspan="2">${itens.length} item(ns)</td>
      <td class="r">${totalPecas > 0 ? fmtNum(totalPecas, 0) : ''}</td>
      <td class="r">${fmtNum(totalQuant)}</td>
      <td colspan="4"></td>
      <td class="r">${fmtMoeda(totalValor)}</td>
      <td></td>
    </tr>
  </tfoot>
</table>`
}

function buildBottomSection (cab) {
  const obs = [cab.OBSERVACOES, cab.OBS3].filter(Boolean).join('\n')
  const formaPgto = cab.OP_FORMA_PAGTO === 'V' ? 'À VISTA' : (cab.OP_FORMA_PAGTO === 'P' ? 'A PRAZO' : (cab.FORMA || ''))

  const financeiro = `
    <div class="fin-row"><span class="fin-label">Forma Pgto:</span><span class="fin-val">${esc(formaPgto)}</span></div>
    ${cab.VL_ENTRADA ? `<div class="fin-row"><span class="fin-label">Entrada:</span><span class="fin-val">R$ ${fmtMoeda(cab.VL_ENTRADA)}</span></div>` : ''}
    ${cab.NR_PARCELAS ? `<div class="fin-row"><span class="fin-label">Parcelas:</span><span class="fin-val">${cab.NR_PARCELAS}x</span></div>` : ''}
    ${cab.PRAZO ? `<div class="fin-row"><span class="fin-label">Prazo (dias):</span><span class="fin-val">${cab.PRAZO}</span></div>` : ''}
    ${cab.DT_INICIAR_PAGAMENTO ? `<div class="fin-row"><span class="fin-label">Início Pgto:</span><span class="fin-val">${fmtDate(cab.DT_INICIAR_PAGAMENTO)}</span></div>` : ''}
    ${cab.DT_PAG ? `<div class="fin-row"><span class="fin-label">Vencimento:</span><span class="fin-val">${fmtDate(cab.DT_PAG)}</span></div>` : ''}`

  const totais = `
    ${cab.VL_TOTAL_PRODUTOS ? `<div class="tot-row"><span class="tot-label">Produtos:</span><span class="tot-val">R$ ${fmtMoeda(cab.VL_TOTAL_PRODUTOS)}</span></div>` : ''}
    ${cab.VL_TOTAL_DESCONTO ? `<div class="tot-row"><span class="tot-label">Desconto:</span><span class="tot-val">- R$ ${fmtMoeda(cab.VL_TOTAL_DESCONTO)}</span></div>` : ''}
    ${cab.VL_TOTAL_FRETE ? `<div class="tot-row"><span class="tot-label">Frete:</span><span class="tot-val">R$ ${fmtMoeda(cab.VL_TOTAL_FRETE)}</span></div>` : ''}
    ${cab.VL_TOTAL_IPI ? `<div class="tot-row"><span class="tot-label">IPI:</span><span class="tot-val">R$ ${fmtMoeda(cab.VL_TOTAL_IPI)}</span></div>` : ''}
    ${cab.VL_TOTAL_ICMS ? `<div class="tot-row"><span class="tot-label">ICMS:</span><span class="tot-val">R$ ${fmtMoeda(cab.VL_TOTAL_ICMS)}</span></div>` : ''}
    ${cab.VL_TOTAL_ST_ICMS ? `<div class="tot-row"><span class="tot-label">ICMS ST:</span><span class="tot-val">R$ ${fmtMoeda(cab.VL_TOTAL_ST_ICMS)}</span></div>` : ''}
    <div class="tot-grand">
      <span>TOTAL FATURA:</span>
      <span>R$ ${fmtMoeda(cab.VL_TOTAL_NFE)}</span>
    </div>`

  // sec-label spans three columns via inline grid
  return `
<div class="sec-label" style="display:grid;grid-template-columns:2fr 1.1fr 1.5fr;">
  <span>Observações</span><span>Financeiro</span><span>Totalizadores</span>
</div>
<div class="bottom-section">
  <div class="bot-box">
    <div class="obs-text">${esc(obs)}</div>
  </div>
  <div class="bot-box">${financeiro}</div>
  <div class="bot-box">${totais}</div>
</div>`
}

function buildParcelamento (parcelamento) {
  if (!parcelamento || parcelamento.length === 0) return ''
  const p = parcelamento[0]
  if (!p || p.OP_FORMA_PAGTO !== 'P') return ''

  const letras = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L']
  const items = letras
    .filter(l => p[`VALOR${l}`] != null)
    .map(l => `<div class="parc-item">
      <div class="parc-lbl">${l})</div>
      <div class="parc-date">${fmtDate(p[`VENCIMENTO${l}`])}</div>
      <div class="parc-val">R$ ${fmtMoeda(p[`VALOR${l}`])}</div>
    </div>`)
    .join('')

  if (!items) return ''

  return `
<div class="sec-label">Parcelamento</div>
<div class="parc-section">
  <div class="parc-grid">${items}</div>
</div>`
}

function buildPesagem (pesagem) {
  if (!pesagem || pesagem.length === 0) return ''

  // Agrupa por PRODUTO_ID mantendo ordem de inserção
  const gruposMap = new Map()
  pesagem.forEach(row => {
    const pid = row.PRODUTO_ID != null ? row.PRODUTO_ID : 0
    if (!gruposMap.has(pid)) {
      gruposMap.set(pid, { nome: row.NOME_PRODUTO || String(pid), rows: [] })
    }
    gruposMap.get(pid).rows.push(row)
  })

  const pesosCols = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

  const sections = Array.from(gruposMap.values()).map(grupo => {
    const headers = pesosCols.map(n => `<th>P${n}</th>`).join('')
    const dataRows = grupo.rows.map(row => {
      const cells = pesosCols.map(n => {
        const v = row[`PESO${n}`]
        return `<td>${v != null ? fmtNum(v) : ''}</td>`
      }).join('')
      return `<tr>${cells}</tr>`
    }).join('')

    return `<div class="pesagem-produto-hdr">${esc(grupo.nome)}</div>
    <table class="pesagem-tbl">
      <thead><tr>${headers}</tr></thead>
      <tbody>${dataRows}</tbody>
    </table>`
  }).join('')

  return `
<div class="sec-label">Pesagem</div>
<div class="pesagem-section">${sections}</div>`
}

function buildValidacao (qrDataUrl, cab) {
  const infoLines = [
    `<strong>Fatura Nº ${esc(String(cab.N_VENDA || ''))}</strong> — Controle: ${esc(String(cab.SEQUENCIA || ''))}`,
    `Emissão: ${cab.DT_SAIDA ? fmtDate(cab.DT_SAIDA) : ''}`,
    `Empresa: ${esc(cab.FANTASIA || cab.TX_RAZAO_SOCIAL || '')}`,
    `Cliente: ${esc(cab.NOME || '')}`,
    `CNPJ/CPF: ${esc(cab.CGC || '')}`,
    `Total: <strong>R$ ${fmtMoeda(cab.VL_TOTAL_NFE)}</strong>`,
  ].join('<br>')

  const qrHtml = qrDataUrl
    ? `<div class="qr-img"><img src="${qrDataUrl}" width="90" height="90" alt="QR Code" /></div>`
    : ''

  return `
<div class="sec-label">Validação do Documento</div>
<div class="validacao-section">
  ${qrHtml}
  <div>
    <div class="qr-info">${infoLines}</div>
    <div class="qr-hint">Escaneie o QR Code para verificar os dados desta fatura.</div>
  </div>
</div>`
}

function buildAssinaturas () {
  return `
<div class="assinatura-section">
  <div class="assin-box">
    <div class="assin-line"></div>
    <div class="assin-label">Assinatura do Cliente</div>
    <div class="assin-sub">Nome / CPF / RG</div>
  </div>
  <div class="assin-box">
    <div class="assin-line"></div>
    <div class="assin-label">Assinatura do Entregador</div>
    <div class="assin-sub">Nome / CPF</div>
  </div>
  <div class="assin-box">
    <div class="assin-line"></div>
    <div class="assin-label">Ciente / Conferência</div>
    <div class="assin-sub">Data: ____/____/____</div>
  </div>
</div>`
}

function buildFooter () {
  return `
<div class="doc-footer">
  <span><strong>CEC Frigo</strong> — Sistema de Controle e Gestão</span>
  <span>Documento de Faturamento</span>
  <span>Impresso: ${new Date().toLocaleString('pt-BR')}</span>
</div>`
}

// ─── Função principal exportada ───────────────────────────────────────────────

export async function imprimirFaturaVenda (vendaId, http) {
  const response = await http.get(`/api/protected/venda/getFaturaVendaData/${vendaId}`)
  const { cabecalho: cab, itens, parcelamento, pesagem } = response.data

  const titulo = `Fatura_${cab.N_VENDA}`

  // Gera QR code com os dados da fatura
  const qrText = [
    `FATURA: ${cab.N_VENDA}`,
    `CONTROLE: ${cab.SEQUENCIA}`,
    `EMISSAO: ${cab.DT_SAIDA ? fmtDate(cab.DT_SAIDA) : ''}`,
    `EMPRESA: ${cab.FANTASIA || cab.TX_RAZAO_SOCIAL || ''}`,
    `CLIENTE: ${cab.NOME || ''}`,
    `CNPJ/CPF: ${cab.CGC || ''}`,
    `TOTAL: R$ ${fmtMoeda(cab.VL_TOTAL_NFE)}`,
  ].join('\n')

  let qrDataUrl = ''
  try {
    qrDataUrl = await QRCode.toDataURL(qrText, { width: 120, margin: 1, errorCorrectionLevel: 'M' })
  } catch (e) {
    console.error('Erro ao gerar QR Code:', e)
  }

  const html = `<!doctype html>
<html>
<head>
  <meta charset="utf-8">
  <title>${esc(titulo)}</title>
  ${buildStyles()}
</head>
<body>
  ${buildCompanyHeader(cab)}
  ${buildIdentBlock(cab)}
  ${buildItemsTable(itens)}
  ${buildBottomSection(cab)}
  ${buildParcelamento(parcelamento)}
  ${buildPesagem(pesagem)}
  ${buildValidacao(qrDataUrl, cab)}
  ${buildAssinaturas()}
  ${buildFooter()}
</body>
</html>`

  imprimir(html, titulo, 'A4', 'portrait')
}



// WEBPACK FOOTER //
// ./src/views/movimentos/vendas/VendaFaturaHTML.js